import React, { useContext, useState } from 'react';
import "../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import InputField from "../../../lib/ui/inputs/Input";
import { LangCtx } from "../../../lib/context";
import { langObj } from "../../../locale/index";
import DropDown from '../../../lib/ui/dropdown/Dropdown';
import { validateEmail } from '../../../lib/validation';

const GuestJoin = (props) => {
    const { l, setLang } = useContext(LangCtx);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const handleSave = (e) => {
        e.preventDefault();
        if (!name || (name && name === "")) {
            setError(l.entr_name);
        } else if (!email || (email && email === "")) {
            setError(l.entr_email);
        } else if(!validateEmail(email)){
            setError("Please enter vaild email")
        } 
        else {
            setError('');
            props.handleSave(name, email);
        }
    }

    const handleLang = (e) => {
        setLang(langObj[e.target.value]);
        localStorage.setItem('lang', e.target.value);
    }
    const langOptions = [{ value: "en", label: l.english }, { value: "hi", label: l.hindi },{ value: "fr", label: l.french }]
    return (
        <div className={props.openGuestInfo ? "btmDtlSlider visible" : "btmDtlSlider"}>
            <div className="btmDtlPaper">
                <div className="btmDtlHeader">
                    <span className="hdrTxt">Guest Login</span>
                </div>
                <div className="btmDtlBdy colBlock">
                    {error && error !== "" && <span className="errorTxt">{error}</span>}
                    <div className="colBlock fullWidth">
                        <form>
                            <small className="inpLabel">{l.guest_name}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.entr_name}
                                type="text"
                                maxLength="30"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <small className="inpLabel">{l.guest_email}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.entr_email}
                                type="text"
                                maxLength="50"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <small className="inpLabel">{l.select_lang}<span className="redTxt">*</span>:</small>
                            <DropDown placeholder="Languages" items={langOptions} value={localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'} onChange={handleLang} />
                        </form>
                    </div>
                </div>
                <div className="hdrAction">
                    {/* <div className="hdrActionBox">
                        <span className="hrActionTxt" onClick={props.closeDelete}>{l.cancel}</span>
                    </div> */}
                    <div className="hdrActionBox" onClick={handleSave}>
                        <span className="hrActionTxt">{l.save}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default GuestJoin;